import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MuiSelect from '@material-ui/core/Select'

export class Select extends Component{
  static propTypes = {
    error: PropTypes.string,
    helperText: PropTypes.string,
    classes: PropTypes.object
  }
  
  static defaultProps = {
    classes: {}
  }

  render = () => {
    const { error, label, helperText, classes, value, multiple, required, ...rest} = this.props
    let sanitizedValue = value
    if(multiple && !Array.isArray(value)) {
      if(value === '' || value === null || value === undefined) {
        sanitizedValue = []
      } else {
        sanitizedValue = Array(value)
      }
    }

    return (
      <FormControl fullWidth={this.props.fullWidth} error={error} className={classes.root}>
        <InputLabel required={required}>{label}</InputLabel>
        <MuiSelect className={classes.select} value={sanitizedValue} multiple={multiple} {...rest}/>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    )
  }

}

export default Select